import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Customer } from '../models/customer';
import { RouterModule, Routes, Router } from '@angular/router';
//import { AppRoutingModule } from '../modules/app-routing.module';

@Injectable()
export class CustomerService {
  newCustomer: Customer;

  constructor(private _http: Http) {
    //let newCustomer = new Customer();
  }

  GetCustomers(): Observable<Array<Customer>> {    
   return this._http.get('/api/customer')
     .map(this.extractData)
     .catch(this.handleError);
 }

 GetCustomer(id: number): Observable<Customer> {    
  return this._http.get('/api/customer/' + id)
    .map(this.extractData)
    .catch(this.handleError);
}

GetProperties(): Observable<Array<Customer>> {    
  return this._http.get('/api/customer/GetProperties')
    .map(this.extractData)
    .catch(this.handleError);
}

Save(item: Customer): Observable<Customer> {    
  return this._http.put('/api/customer', item)
    .map(this.extractData)
    .catch(this.handleError);
}

Create(item: Customer): Observable<Customer> {    
  return this._http.post('/api/customer', item)
    .map(this.extractData)
    .catch(this.handleError);
}

EmailSftp(item: Customer): Observable<Customer> {    
  return this._http.post('/api/customer/emailsftp', item)
    .map(this.extractData)
    .catch(this.handleError);
}

Delete(item: Customer): Observable<Customer> {    
  return this._http.delete('/api/customer/' + item.CustomerId)
    .map(this.extractData)
    .catch(this.handleError);
}

Download(): Observable<any> { 
  return this._http.get('/api/customer/download', {responseType: ResponseContentType.Blob})
    .map(response => (<Response>response).blob())
    .catch(this.handleError);
}

 private extractData(res: Response) {
   let body: any;
     try {
       body = res.json();
     } catch (ex) {
       body = res.text();
     } 
   
   return body || {};
 }

 private handleError(error: Response | any) {
   // In a real world app, we might use a remote logging infrastructure
   let errMsg: string;
   if (error instanceof Response) {
     
     let body: any;
     try {
       body = error.json();
     } catch (ex) {
       body = error.text();
     } 
     //err = body.error || JSON.stringify(body);
     errMsg = `${error.status} - ${error.statusText || ''} ${body}`;
   } else {
     
     errMsg = error.message ? error.message : error.toString();
   }
   console.error(errMsg);
   return Observable.throw(errMsg);
 }
}



// WEBPACK FOOTER //
// ./src/app/services/customer.service.ts